// extracted by mini-css-extract-plugin
export default {"hello":"login_hello__v12n5","image":"login_image__zxsIJ","forCenter":"login_forCenter__sF952","card":"login_card__NKqRK"};